export const PREFERRED_LANGUAGE_GATE = 'PortalsPlatform::SupportPreferredLanguage';
export const CREATE_SPACE_GATE = 'PortalsPlatform::UnifiedShell::CreateSpace';